let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1XGRs")).then(() => parcelRequire('8DB98'));